import { Section, Overline } from "./Shared";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

export const FaqSection = ({ items, title = "Frequently asked questions", intro }) => (
  <Section className="pt-0" id="faq">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4">
        <Overline>FAQ</Overline>
        <h2 className="mt-4 text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">{title}</h2>
        {intro && <p className="mt-4 text-lg text-slate-600">{intro}</p>}
      </div>
      <div className="lg:col-span-8">
        <Accordion type="single" collapsible className="rounded-2xl border border-slate-200 bg-white shadow-[0_4px_20px_rgba(15,23,42,0.04)] px-6" data-testid="faq-accordion">
          {items.map((f, i) => (
            <AccordionItem key={f.q} value={`faq-${i}`} className="border-slate-200">
              <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left text-lg font-semibold text-slate-900 hover:text-cyan-700 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-slate-700 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </Section>
);
